export default __webpack_public_path__ + "static/media/other-cost.adbd19c1.svg";